
import { StoryboardFrame, StoryboardGenerationOptions } from '@/features/storyboard/types/storyboard.types';
import { useAppMutation } from '@/shared/hooks/useAppMutation';
import { AppError } from '@/shared/types/AppError';
import { HookOptions } from '@/shared/types/HookOptions';
import { storyboardAIService } from '../service/storyboard.ai.service';

export const useGenerateStoryboardMutation = (options?: HookOptions<StoryboardFrame[], AppError, { sceneText: string, options?: StoryboardGenerationOptions }>) => {
    return useAppMutation<StoryboardFrame[], AppError, { sceneText: string, options?: StoryboardGenerationOptions }>({
        mutationFn: (vars) => storyboardAIService.generateStoryboard(vars.sceneText, vars.options),
    }, options);
};

export const useGenerateFrameImageMutation = (options?: HookOptions<{ success: boolean; imageUrl: string }, AppError, { frameId: string; prompt: string; referenceImageUrl?: string }>) => {
    return useAppMutation<{ success: boolean; imageUrl: string }, AppError, { frameId: string; prompt: string; referenceImageUrl?: string }>({
        mutationFn: (vars) => storyboardAIService.generateFrameImage(vars.frameId, vars.prompt, vars.referenceImageUrl),
    }, options);
};

export const useRegenerateFrameMutation = (options?: HookOptions<StoryboardFrame, AppError, { frame: Partial<StoryboardFrame>; sceneText: string }>) => {
    return useAppMutation<StoryboardFrame, AppError, { frame: Partial<StoryboardFrame>; sceneText: string }>({
        mutationFn: (vars) => storyboardAIService.regenerateSingleFrame(vars.frame, vars.sceneText),
    }, options);
};
